module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_hokkaido-63b10c1aa6e521bdce8e3c69892881a9.webp";